import { createFileRoute, Navigate } from '@tanstack/react-router';
import { useAuth } from '@weebee/api';
import { BrandMark } from '@/components/shared/brand-mark';

export const Route = createFileRoute('/')({
  component: IndexRedirect,
});

function IndexRedirect() {
  const authState = useAuth();

  if (authState.status === 'loading') {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-center">
          <BrandMark className="h-10 mb-3 animate-pulse" />
          <p className="text-sm text-muted-foreground">Loading...</p>
        </div>
      </div>
    );
  }

  if (authState.status === 'unauthenticated') {
    return <Navigate to="/login" />;
  }

  return <Navigate to="/app" />;
}
